import { Steps } from 'antd';
import "./stepper.scss";
import { useTranslation } from 'react-i18next';
const { Step } = Steps;

const Stepper = ({ currentStep, steps } : { currentStep: number, steps: string[] }) => {
    const { t } = useTranslation();

    return <div className="stepper-container">
    <Steps current={currentStep} size="small" labelPlacement="vertical">
        {steps.map((label, i) => (
            <Step
                key={i}
                status={i < currentStep ? 'finish' : i === currentStep ? 'process' : 'wait'}
                style={{ cursor: i <= currentStep ? 'pointer' : 'default' }}
                title={t(label)}
            />
        ))}
    </Steps>
</div>
}

export default Stepper;